import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import { Divider, Input, Icon, Image } from 'semantic-ui-react';
import TargetLink from '../../components/target-link';
import { renderCurrencySymbol } from '../../utils/helpers/currencies';
import ThemeSelector from '../../themes/theme-selector';

const HELP_URL = 'https://help.dyzio.co/campaign-reports/roi-report';

const icon = <Icon name="save" />;

const textCenter = {
  textAlign: 'center',
};

class InfluencerFeeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.budget || '',
    };
  }

  onInputValueChanged = (event, { value }) => {
    this.setState({
      value,
    });
  }

  render() {
    const { value } = this.state;
    const hasInvalidValue = _.isEmpty(value) || _.isNaN(_.toNumber(value));
    const {
      onClose,
      currency,
      influencer,
      onSubmit,
    } = this.props;
    const { disableHelpLinks } = ThemeSelector.theme();
    return (
      <DyzioModal
        headerText="Influencer Fee"
        onClose={onClose}
        size="tiny"
        hasActionButton
        actionButtonContent="Save"
        actionButtonIcon={icon}
        shouldDisableActionButton={hasInvalidValue}
        onActionButtonClick={() => onSubmit(value)}
      >
        <Image centered src={influencer.thumbnail} className="circular" size="small" />
        <Divider hidden fitted />
        <h3 style={textCenter}>{influencer.name}</h3>
        <Divider />
        <h4>
            Enter the fee paid to the influencer in the box below.
            This fee will flow through to the ROI report on the dashboard.
        </h4>
        <Divider hidden />
        <Input
          onChange={this.onInputValueChanged}
          value={value}
          type="number"
          label={renderCurrencySymbol(currency)}
          placeholder="Influencer fee"
          fluid
        />
        <small>*only numbers allowed</small>
        <Divider hidden />
        {!disableHelpLinks && (<TargetLink href={HELP_URL} renderIf>
          click here for help and FAQs
        </TargetLink>)}
      </DyzioModal>
    );
  }
}
InfluencerFeeModal.propTypes = {
  currency: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  influencer: PropTypes.object.isRequired,
  budget: PropTypes.any.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default InfluencerFeeModal;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-fee-modal/index.js
 **/